import React from "react";
import Slider from "react-slick";
import { Box, IconButton, Image } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";

const logos = [
  "/logo (1).png",
  "/logo (1).png",
  "/logo (1).png",
 "/logo (1).png",
  "/logo (1).png",
  "/logo (1).png",
];

const LogoCarousel = () => {
  const sliderRef = React.useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, 
    slidesToScroll: 1,
    arrows: false, 
    autoplay: true,
    autoplaySpeed: 2500,
  };

  return (
    <Box  position="relative" w="100%" >
      {/* Left Arrow */}
      <IconButton
        aria-label="Previous"
        icon={<ChevronLeftIcon />}
        position="absolute"
        left="50px"
        top="50%"
        transform="translateY(-50%)"
        zIndex={2}
        onClick={() => sliderRef.current.slickPrev()}
        color="orange.500"
        bg="white"
        _hover={{ bg: "gray.100" }}
        borderRadius="full"
      />

      {/* Carousel */}
      <Slider ref={sliderRef} {...settings}>
        {logos.map((logo, idx) => (
          <Box  key={idx} px="200px" h="60px" width="full" justifyContent="space-evenly" display="flex" alignItems="center">
            <Image  src={logo} alt={`logo-${idx}`}  width="100px"   maxH="60px"    objectFit="contain" />
          </Box>
        ))}
      </Slider>

      {/* Right Arrow */}
      <IconButton
        aria-label="Next"
        icon={<ChevronRightIcon />}
        position="absolute"
        right="50px"
        top="50%"
        transform="translateY(-50%)"
        zIndex={2}
        onClick={() => sliderRef.current.slickNext()}
        color="orange.500"
        bg="white"
        _hover={{ bg: "gray.100" }}
        borderRadius="full"
      />
    </Box>
  );
};

export default LogoCarousel;
